import React from 'react'
import { Box, Icon, Stack, Collapse, useColorModeValue, useDisclosure } from '@chakra-ui/react'
import { ChevronDownIcon } from '@chakra-ui/icons'
import MenuItem from '../Menu/menuItem'

const DropDownMobileMenu = ({ menu }) => {
    const { isOpen, onToggle } = useDisclosure()
    const stackBg = useColorModeValue('gray.100', 'gray.900')

    const handleClick = (event) => {
        event.stopPropagation()
        onToggle()
    }

    return (
        <Stack spacing={4} onClick={handleClick} width={'100%'} m={0}>
            <Box
                m={0}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                borderBottom={'1px solid #777'}
                _hover={{
                    textDecoration: 'none',
                }}
                spacing={0}
                fontSize={'16px'}
                fontWeight={'bold'}
            >
                <MenuItem padding={3} menu={menu}>
                    {menu.title}
                </MenuItem>
                {menu?.subItems && (
                    <Icon
                        as={ChevronDownIcon}
                        transition={'all .25s ease-in-out'}
                        transform={isOpen ? 'rotate(180deg)' : ''}
                        w={9}
                        h={9}
                        mr={2}
                    />
                )}
            </Box>
            {menu?.subItems && (
                <Collapse key={menu.id} className={'nomargin'} in={isOpen} animateOpacity>
                    <Stack align={'start'} bg={stackBg} w={'100%'} spacing={0}>
                        {menu?.subItems.map((item) => (
                            <DropDownMobileMenu key={item.id} menu={item} />
                        ))}
                    </Stack>
                </Collapse>
            )}
        </Stack>
    )
}

export default DropDownMobileMenu
